import { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { hasUserSession } from "../auth/session";
import { apiCall } from "../utils/apiService";
import "./AuthPage.css";

const SignInLayer = () => {
    const { loginUser } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        try {
            const data = await apiCall({
                url: `user/login`,
                method: "Post",
                body: { email, password },
            });

            if (data.token) {
                // Does not clear admin session
                loginUser(data.token, {
                    uid: data.uid,
                    user: data.user,
                    apiKey: data.apiKey,
                    instanceLimit: data.instanceLimit,
                });
                window.location.href = "/dashboard";
            } else {
                setError("Invalid email or password");
            }
        } catch (err) {
            setError("Invalid email or password");
            console.error("Login error:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (hasUserSession()) {
            window.location.href = "/dashboard";
        } else {
            document.title = "Sign In";
        }
    }, []);

    return (
        <div className="auth-page">
            <div className="auth-shell">
                <aside className="auth-aside">
                    <div>
                        <Icon icon="mdi:whatsapp" width={36} />
                        <h2>WhatsApp messaging, made simple</h2>
                        <p>
                            Connect sessions, send campaigns, and monitor delivery from one
                            AlphaXCloud workspace.
                        </p>
                        <ul className="auth-aside-points">
                            <li><span className="dot" /> Multi-session WhatsApp inbox</li>
                            <li><span className="dot" /> Bulk campaigns & templates</li>
                            <li><span className="dot" /> Live logs and API access</li>
                        </ul>
                    </div>
                    <p style={{ opacity: 0.8, fontSize: "0.8rem" }}>© AlphaXCloud</p>
                </aside>

                <div className="auth-panel">
                    <Link to="/" className="d-block text-center">
                        <img
                            className="auth-logo"
                            src="/assets/images/alphaxcloud.svg"
                            alt="AlphaXCloud"
                        />
                    </Link>
                    <h6>Sign in to your account</h6>
                    <p className="auth-sub">Welcome back — enter your details to continue</p>

                    <form onSubmit={handleSubmit}>
                        <div className="icon-field">
                            <span className="icon">
                                <Icon icon="mage:email" />
                            </span>
                            <input
                                type="email"
                                className="form-control"
                                placeholder="Email"
                                value={email}
                                required
                                autoComplete="username"
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <div className="password-field">
                            <div className="icon-field">
                                <span className="icon">
                                    <Icon icon="solar:lock-password-outline" />
                                </span>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className="form-control"
                                    placeholder="Password"
                                    value={password}
                                    required
                                    autoComplete="current-password"
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <button
                                type="button"
                                className="toggle-password"
                                aria-label={showPassword ? "Hide password" : "Show password"}
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                <Icon
                                    icon={showPassword ? "mdi:eye-off-outline" : "mdi:eye-outline"}
                                    width={18}
                                    height={18}
                                />
                            </button>
                        </div>

                        {error ? <div className="auth-error">{error}</div> : null}

                        <button type="submit" className="auth-submit" disabled={isLoading}>
                            {isLoading ? "Signing in…" : "Sign in"}
                        </button>

                        <div className="auth-footer">
                            Don&apos;t have an account? <Link to="/register">Sign up</Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SignInLayer;
